import { ProgramGoal, PROGRAM_GOALS_QUERY_KEY } from './useProgramGoals';
import { createCrudHooks } from '../utils/createCrudHooks';

const { useCreate, useUpdate, useDelete } = createCrudHooks<ProgramGoal>({
  endpoint: '/api/program-goals',
  queryKey: PROGRAM_GOALS_QUERY_KEY,
  getId: pg => pg.programgoalid,
});

export const useCreateProgramGoal = useCreate;
export const useUpdateProgramGoal = useUpdate;
export const useDeleteProgramGoal = useDelete;
